<div class="assessment-categories" appBlockCopyPaste>
    <app-candidate-header></app-candidate-header>

    <div class="categories-container">
        <!-- Simplified Header -->
        <div class="main-header">
            <div class="header-content">
                <h1 class="main-title">Assessment Modules</h1>
                <div class="user-info">
                    <span class="user-name">{{assessmentInfo?.candidateName || 'User'}}</span>
                    <span class="separator">•</span>
                    <span class="assessment-name">{{assessmentInfo?.name}}</span>
                    <span class="separator">•</span>
                    <span class="duration">
                        <mat-icon>schedule</mat-icon>
                        {{assessmentInfo?.duration}} mins
                    </span>
                </div>
            </div>
        </div>

        <!-- Progress Indicator - Only for multiple modules -->
        <div class="progress-banner" *ngIf="categories?.length > 1 && getCompletedCount() > 0">
            <div class="progress-info">
                <span class="progress-text">Progress: {{getCompletedCount()}} of {{categories?.length}} modules
                    completed</span>
                <span class="progress-percentage">{{getProgressPercentage()}}%</span>
            </div>
            <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="getProgressPercentage()"></div>
            </div>
        </div>

        <!-- Module Cards -->
        <div class="modules-list">
            <div class="module-card" *ngFor="let category of categories; let i = index"
                [class.status-completed]="category?.categoryStatus === 'COMPLETED'"
                [class.status-progress]="category?.categoryStatus === 'IN_PROGRESS'">

                <div class="module-icon" [ngClass]="getModuleIconClass(category)">
                    <mat-icon>{{getCategoryIcon(category?.questionType)}}</mat-icon>
                </div>

                <div class="module-info">
                    <h3 class="module-title">{{questionType[category?.questionType]}}</h3>
                    <div class="module-meta">
                        <span class="meta-item">
                            <mat-icon>description</mat-icon>
                            {{category?.totalQuestions}} {{category?.totalQuestions === 1 ? 'question' : 'questions'}}
                        </span>
                        <span class="meta-item">
                            <mat-icon>schedule</mat-icon>
                            {{category?.durationInMins}} mins
                        </span>
                    </div>
                </div>

                <!-- Only show button if NOT completed -->
                <div class="module-action" *ngIf="category?.categoryStatus !== 'COMPLETED'">
                    <button mat-raised-button class="action-btn" [ngClass]="getButtonClass(category)"
                        (click)="beginAssessment(category?.questionType, category?.durationInMins)">
                        <mat-icon>{{getButtonIcon(category)}}</mat-icon>
                        <span>{{questionCategoryStatus[category?.categoryStatus]}}</span>
                    </button>
                </div>

                <!-- Completion Badge -->
                <div class="completion-badge" *ngIf="category?.categoryStatus === 'COMPLETED'">
                    <mat-icon>check_circle</mat-icon>
                </div>
            </div>
        </div>

        <!-- Submit Section -->
        <div class="submit-section">
            <!-- Info message -->
            <div class="submit-message info-message" *ngIf="disableSubmit">
                <mat-icon>info_outline</mat-icon>
                <ng-container *ngIf="categories?.length === 1; else multipleModulesInfo">
                    <p>Complete this module to submit your assessment</p>
                </ng-container>
                <ng-template #multipleModulesInfo>
                    <p>Complete at least one module to submit your assessment</p>
                </ng-template>
            </div>

            <!-- Warning message -->
            <div class="submit-message warning-message"
                *ngIf="!disableSubmit && !allModulesCompleted() && categories?.length > 1">
                <mat-icon>warning_amber</mat-icon>
                <p>You haven't completed all modules. You can still submit, but consider finishing all sections.</p>
            </div>

            <!-- Success message -->
            <div class="submit-message success-message" *ngIf="allModulesCompleted()">
                <mat-icon>check_circle_outline</mat-icon>
                <ng-container *ngIf="categories?.length === 1; else multipleModulesSuccess">
                    <p>Excellent! You've completed the module. Ready to submit.</p>
                </ng-container>
                <ng-template #multipleModulesSuccess>
                    <p>Excellent! You've completed all modules. Ready to submit.</p>
                </ng-template>
            </div>

            <button mat-raised-button class="submit-btn" [disabled]="disableSubmit" (click)="submitAssessment()">
                <span>Submit Assessment</span>
                <mat-icon>send</mat-icon>
            </button>
        </div>
    </div>
</div>